
(function() {
  var MODAL_ID = 'age-verification-modal';

  function createModal() {
    if (document.getElementById(MODAL_ID)) return;
    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.style.cssText = 'display:none;position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.6);align-items:center;justify-content:center;';
    modal.innerHTML = `
      <div style="background:#fff;border-radius:8px;max-width:420px;width:90%;padding:32px 28px;text-align:center;font-family:inherit;">
        <p style="font-size:1.5rem;margin:0 0 8px;">🔞</p>
        <h2 style="font-size:1.2rem;font-weight:700;margin:0 0 12px;">Verifica dell'età</h2>
        <p style="font-size:0.95rem;color:#444;margin:0 0 24px;line-height:1.5;">
          Questo prodotto contiene alcol. Confermando dichiari di avere almeno <strong>18 anni</strong> e di assumere piena responsabilità per l'acquisto.
        </p>
        <div style="display:flex;gap:12px;justify-content:center;">
          <button id="age-verify-confirm" style="flex:1;padding:12px;background:#000;color:#fff;border:none;border-radius:4px;font-size:0.95rem;cursor:pointer;font-family:inherit;">
            Confermo, ho 18+ anni
          </button>
          <button id="age-verify-cancel" style="flex:1;padding:12px;background:#fff;color:#000;border:1px solid #000;border-radius:4px;font-size:0.95rem;cursor:pointer;font-family:inherit;">
            Annulla
          </button>
        </div>
      </div>`;
    document.body.appendChild(modal);

    document.getElementById('age-verify-cancel').addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  }

  var pendingSubmit = null;

  function openModal(submitFn) {
    pendingSubmit = submitFn;
    var modal = document.getElementById(MODAL_ID);
    modal.style.display = 'flex';
    document.getElementById('age-verify-confirm').onclick = function() {
      closeModal();
      if (pendingSubmit) { pendingSubmit(); pendingSubmit = null; }
    };
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.style.display = 'none';
    pendingSubmit = null;
  }

  function isAlcohol(form) {
    var wrapper = form.closest('[data-alcohol="true"]');
    return !!wrapper;
  }

  function interceptForms() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (!isAlcohol(form)) return;
      if (form.dataset.ageVerified === 'true') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openModal(function() {
        form.dataset.ageVerified = 'true';
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }, true);

    // Also intercept direct button clicks (for themes using JS submit)
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('button[name="add"], button[type="submit"]');
      if (!btn) return;
      var form = btn.closest('form[data-type="add-to-cart-form"]');
      if (!form || !isAlcohol(form)) return;
      if (form.dataset.ageVerified === 'true') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openModal(function() {
        form.dataset.ageVerified = 'true';
        btn.click();
      });
    }, true);
  }

  window.__ageVerifyOpen = function (fn) {
    createModal();
    openModal(fn);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { createModal(); interceptForms(); });
  } else {
    createModal(); interceptForms();
  }
})();
